<template>
  <portal :to="portal">
    <transition name="slide">
      <div
        :class="classes"
        @click.self="close"
        @scroll="scroll"
      >
        <div class="popup-modal-content">
          <div class="popup-modal-header">
            <h2
              v-if="title"
              class="app-h2 popup-modal-title"
            >
              {{ title }}
            </h2>

            <button
              v-if="closable"
              class="popup-modal-close"
              @click="close"
            >
              <font-awesome-icon icon="times" />
            </button>
          </div>

          <slot />
        </div>
      </div>
    </transition>
  </portal>
</template>

<script>
  export default {
    name: 'PopupModal',
    props: {
      title: {
        type: String,
        default: '',
      },
      center: {
        type: Boolean,
        default: false,
      },
      customClass: {
        type: String,
        default() {
          return '';
        },
      },
      closable: {
        type: Boolean,
        default: true,
      },
      small: {
        type: Boolean,
        default: false,
      },
      portal: {
        type: String,
        default: 'popups',
      },
    },
    computed: {
      classes() {
        const classes = [this.customClass, 'popup-modal'];

        if (this.center) {
          classes.push('popup-modal-center');
        }

        if (this.small) {
          classes.push('popup-modal-small');
        }

        if (!this.closable) {
          classes.push('popup-modal-unclosable');
        }

        return classes;
      },
    },
    methods: {
      scroll(e) {
        this.$emit('scroll', e);
      },
      close() {
        if (!this.closable) {
          return;
        }

        this.$emit('close');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .popup-modal {
    background-color: $shadow;
    backdrop-filter: blur(5px);
    bottom: 0;
    color: $black;
    left: 0;
    padding: env(safe-area-inset-top, #{$gutter-smaller}) $gutter-smaller;
    position: fixed;
    right: 0;
    top: 0;
    z-index: calc(var(--cordel-legacy-z-index-max) + 1);

    overflow-y: scroll;
    overflow-x: hidden;

    @include prefix(overflow-scrolling, touch);

    @media all and (min-width: $breakpoint-desktop) {
      padding: $gutter-big;
    }
  }

  .popup-modal-header {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    min-height: $button;

    @media all and (min-width: $breakpoint-desktop) {
      min-height: $button-big;
    }

    .popup-modal-unclosable & {
      min-height: $button-big;
    }
  }

  .popup-modal-title {
    flex: 1;
    padding: $gutter-small 0 $gutter-small $gutter;

    @media all and (min-width: $breakpoint-desktop) {
      padding-left: $gutter-bigger;
    }

    .popup-modal-unclosable & {
      text-align: center;
      padding-left: 0;
    }
  }

  .popup-modal-close {
    @include button-reset;

    align-items: center;
    display: flex;
    font-size: $font-big;
    height: $button;
    justify-content: center;
    width: $button;

    @media all and (min-width: $breakpoint-desktop) {
      height: $button-big;
      width: $button-big;
    }
  }

  .popup-modal-content {
    background-color: $white;
    margin: 0 auto;

    @media all and (min-width: $breakpoint-desktop) {
      box-shadow: 0 $gutter $gutter (-$gutter) $shadow;
      max-width: 480px;
    }

    .popup-modal-small & {
      max-width: 320px;
    }

    .popup-modal-center & {
      left: $gutter-smaller;
      position: absolute;
      right: $gutter-smaller;
      top: 50%;
      transform: translateY(-50%);

      @media all and (min-width: $breakpoint-desktop) {
        left: 0;
        right: 0;
      }
    }
  }
</style>
